
    import { defineComponent, ref } from 'vue'
    import AutoComplete from 'primevue/autocomplete'
    import AutoCompleteEvent, { AutoCompleteEventSelectedEvent, } from '@/models/prime-events'
    import Calendar from 'primevue/calendar'
    import Button from 'primevue/button'
    import ToggleButton from 'primevue/togglebutton'
    import { useStore } from 'vuex'
    import { storeKey } from '@/store'
    import 'firebase/database'
    import { Thumbnail } from '@/models/musical-poster'
    import MusicalSuggestion from '@/models/musical-search'
    import Knob from 'primevue/knob'
    import ItemData from '@/models/item'

    export default defineComponent({
        name: 'AddMusical',
        components: {
            AutoComplete,
            Knob,
            Calendar,
            Button,
            ToggleButton
        },
        emits: ['saved'],
        setup(props, { emit }) {
            const suggestions = ref<string[]>([])
            const selectedMusical = ref<MusicalSuggestion>()
            const rating = ref<number>(0)
            const selectedDate = ref<Date>()
            const invalid = ref(false)
            const saving = ref(false)
            const flagged = ref(false)
            const itemSelected = ref(false)
            const store = useStore(storeKey)
            const poster = ref<Thumbnail>()

            const musicalSelected = async (event: AutoCompleteEventSelectedEvent<MusicalSuggestion>) => {
                itemSelected.value = true
                poster.value = await store.dispatch(
                    'musicals/loadPoster',
                    event.value.title
                )
            }

            const musicalCleared = () => {
                itemSelected.value = false
            }

            const save = async () => {
                invalid.value = selectedMusical.value === undefined

                if (invalid.value) {
                    return
                }

                const musical: ItemData = {
                    name: selectedMusical.value?.title || '',
                    posterUrl: poster.value?.source || '',
                    posterWidth: poster.value?.width || 0,
                    myRating: rating.value || 0,
                    globalRating: 0,
                    year: selectedDate.value,
                    id: 0,
                    flagged: flagged.value
                }

                saving.value = true
                await store.dispatch('musicals/addItem', musical)
                emit('saved')
            }

            const musicalSearch = async (event: AutoCompleteEvent) => {
                suggestions.value = await store.dispatch(
                    'musicals/loadSuggestions',
                    event.query.trim()
                )
            }

            return {
                musicalSearch,
                selectedMusical,
                suggestions,
                rating,
                selectedDate,
                save,
                invalid,
                saving,
                poster,
                flagged,
                musicalSelected,
                itemSelected,
                musicalCleared,
            }
        },
    })
